/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class ButtonList extends React.Component {
	render() {
		return (
			<nav className={this.props.wrapperClass}>
			{this.props.buttons.map(function(button, i){
				var linkClass = this.props.linkClass,
					errorIndicator = null;

				if (button.isActive !== undefined && button.isActive) {
					linkClass += " " + this.props.activeClass;
				}

				if (button.hasErrors !== undefined && button.hasErrors === true) {
					errorIndicator = (
						<div className="error-indicator"/>
					);
				}

				if (button.handler !== undefined) {
					return (
						<span className={linkClass} key={i} onClick={button.handler} data-panel={button.data} role="button" aria-label={button.label}>
							{button.label}{errorIndicator}
						</span>
					);
				} else {
					return (
						<Link to={button.link} className={linkClass} key={i}>{button.label}{errorIndicator}</Link>
					);
				}

			}, this)}
			</nav>
		);
	}
};

ButtonList.displayName = "ButtonList";

ButtonList.propTypes = {
	buttons: PropTypes.array,
	wrapperClass: PropTypes.string,
	linkClass: PropTypes.string,
	activeClass: PropTypes.string,
	errorClass: PropTypes.string
};

ButtonList.defaultProps = {
	buttons: [],
	wrapperClass: '',
	linkClass: '',
	activeClass: '',
	errorClass: ''
};

export default ButtonList;
